import { render, staticRenderFns } from "./dataAgentPage.vue?vue&type=template&id=d37f4372&"
import script from "./dataAgentPage.vue?vue&type=script&lang=js&"
export * from "./dataAgentPage.vue?vue&type=script&lang=js&"
import style0 from "./dataAgentPage.vue?vue&type=style&index=0&id=d37f4372&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports